import { useEffect, useRef } from "react";
import { usePostHog } from "posthog-js/react";
import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";
import { LaunchError } from "../utils/errors";
import {
  POSTHOG_ACCOUNT_IDS_SENTRY_META,
  shouldIdentifyPostHogUser,
  updatePostHogUserSession,
} from "../utils/posthogAccountProperties";

const usePostHogAccountProperties = () => {
  const posthog = usePostHog();
  const dispatch = useDispatchApp();
  const uid = useSelectorApp((state) => state.auth.user?.uid);
  const agencyID = useSelectorApp((state) => state.auth.user?.agencyID);
  const advertiserID = useSelectorApp((state) => state.auth.user?.advertiserID);
  const syncedRef = useRef(null);

  useEffect(() => {
    // PostHog is only initialized in production (VITE_IS_STAGING === "false").
    if (!posthog?.__loaded) return;
    try {
      let role;
      let companyID;
      if (uid && shouldIdentifyPostHogUser({ posthog, uid })) {
        const path = dispatch(getPathDatabaseByRole());
        role = path.role;
        companyID = path.userID;
      }
      syncedRef.current = updatePostHogUserSession({
        posthog,
        previous: syncedRef.current,
        uid,
        role,
        companyID,
        agencyID,
        advertiserID,
      });
    } catch (error) {
      dispatch(LaunchError(error, false, [], POSTHOG_ACCOUNT_IDS_SENTRY_META));
    }
  }, [posthog, dispatch, uid, agencyID, advertiserID]);
};

export default usePostHogAccountProperties;
